<div class="transport-details-list-entry">
  <div class="information">
    <div class="info-button">
      <app-transport-details-dialog-action [transport]="transport.transport" [asButton]="true" (onChange)="triggerUsageRefresh()" [dashboardContext]="dashboardContext"></app-transport-details-dialog-action>
      <!-- <button mat-stroked-button (click)="showTransportInfos()"><sc-icon iconClass="fa-info"></i></button> -->
    </div>
    <div class="row" *ngIf="transport">
      <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
        [transport]="transport.transport">
      </app-transport-details>
    </div>
  </div>

  <div class="actions">
    <ng-container *ngFor="let mk of transport.messageKeys">
      <div class="notification">
        {{ mk | translate: [ mk, translationService.language] }}
      </div>
    </ng-container>
    <div class="notification"
      *ngIf="featureUmbrueckungEnabled && transport.completeUmbrueckungAllowed && transport.completeUmbrueckungEnabled">
      <div [innerHTML]="'the trailer of the selected transport of currently beeing swapped, you can cancel or complete this process.' | translate: ['tmc.complete-umbrueckung-dialog.info-text', translationService.language] |
      trustHtml">
      </div>
    </div>
    <div class="action-bar" *ngIf="transport.assignAllowed">
      <button mat-flat-button (click)="assignTransportToStation()">
        {{'assign' | translate : ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.assign',
        translationService.language]}}
      </button>
    </div>
    <ng-container *ngIf="featureMovingOrderActive">
      <div class="action-bar" *ngIf="transport.createMovementOrderAllowed">
        <button mat-flat-button (click)="createMovementOrder()">
          {{'create moving order' | translate : ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.create-moving-order',
          translationService.language]}}
        </button>
      </div>
    </ng-container>
    <div class="action-bar" *ngIf="station?.stationUsage?.plannedTransportAssignmentPossible && station?.stationUsage?.transports.length>0 && !transport.plannedForAssignment">
      <button mat-flat-button (click)="planAssignment()">
        {{'plan assignment' | translate : ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.plan-assignment',
        translationService.language]}}
      </button>
    </div>
    <ng-container *ngIf="featureUmbrueckungEnabled">
      <div class="action-bar" *ngIf="transport.startUmbrueckungAllowed">
        <button mat-flat-button (click)="startUmbrueckung()" [disabled]="!transport.startUmbrueckungEnabled">
          {{'start umbrueckung' | translate :
          ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.start-umbrueckung',
          translationService.language]}}
        </button>
      </div>
      <div class="action-bar" *ngIf="transport.completeUmbrueckungAllowed">
        <button mat-stroked-button (click)="cancelUmbrueckung()" [disabled]="!transport.completeUmbrueckungEnabled">
          {{'cancel umbrueckung' | translate :
          ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.cancel-umbrueckung',
          translationService.language]}}</button>
        <div class="spacer"></div>
        <button mat-flat-button (click)="completeUmbrueckung()" [disabled]="!transport.completeUmbrueckungEnabled">
          {{'complete umbrueckung' | translate :
          ['tmc-yard.widgets.sac-client.transport-details-list-entry.action.complete-umbrueckung',
          translationService.language]}}
        </button>
      </div>
    </ng-container>
  </div>
</div>
